import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { ALL_DOCUMENT_TYPES } from '../../../broker/constants/constants';
import { REGEX } from '@constants/common/regex';
import { FIRST_NAME_REGEX } from '@utils/validators/regex';

import { getDateDifference, dayjsUtil, getDateTimeInMillisecond, parseDate } from '@utils/dates/date.utils';

const checkRegex = (value, regex, affordableValues = undefined, reverse = undefined) => {
    if (affordableValues && affordableValues.includes(value)) {
        return true;
    } else {
        if (value === null) {
            return false;
        } else {
            return reverse ?
                !(value && value.match(regex)) :
                !!(value && value.match(regex));
        }
    }
};

export const methods = {

    alphanumeric: ([value]) => checkRegex(value, /^[A-Za-z0-9]/),

    certificateOfNaturalizationNumber: ([value]) => value === null || value === '' || checkRegex(String(value), /^\d{6,12}$/),

    checked: ([value]) => !!value,

    checkIfUnique: ([value, setOfUniques]) => !setOfUniques.has(value),

    dateCheck: ([value, dateToCheckWith, conditionToCheck]) => {
        switch (conditionToCheck) {
            case VALIDATION_TYPES.DATE_NOT_GREATER_THAN_CURRENT:
                return getDateTimeInMillisecond(value) <= getDateTimeInMillisecond(dateToCheckWith);
            case VALIDATION_TYPES.DATE_GREATER_THAN_START:
                return getDateTimeInMillisecond(value) <= getDateTimeInMillisecond(dateToCheckWith);
            default:
                return true;
        }

    },

    validateDate: ([value]) => {
        if (!value) return false;
        const dateArr = value.split('-');
        let daysInMo;
        switch (dateArr[1]) {
            case '02':
                if (dateArr[0] % 4 === 0) {
                    daysInMo = 29;
                } else {
                    daysInMo = 28;
                }
                break;
            case '04':
            case '06':
            case '09':
            case '11':
                daysInMo = 30;
                break;
            default:
                daysInMo = 31;
        }
        return (!(dateArr[1] > 12 ||
            dateArr[2] > daysInMo ||
            dateArr[0] < 1 ||
            dateArr[1] < 1 ||
            parseInt(dateArr[0]) < 1000));
    },

    validateBirthDateWithCoverageStartDate: ([value, , name, effectiveDate]) => {
        if (value !== 0 && value !== '' && value !== null) {
            const birthday = dayjsUtil(value);
            effectiveDate = parseDate(effectiveDate);
            name = name.includes('dateOfBirth_child') ? 'dateOfBirth_child' : name;
            switch (name) {
                case 'dateOfBirth_spouse':
                    return getDateDifference(effectiveDate, birthday, 'year') > 18;
                // return effectiveDate.diff(birthday, 'years') > 18;
                case 'dateOfBirth_child':
                    return effectiveDate.diff(birthday, 'years') <= 26;
                case 'dateOfBirth_applicant':
                    return effectiveDate.diff(birthday, 'years') <= 120;
                default: return true;
            }
        }
        return false;

    },
    validateDependantAgeForTobaccoUse: ([value, ageLimit, effectiveDate]) => {
        if (methods.validateDate([value])) {
            if (value !== 0 && value !== '' && value !== null) {
                const birthday = parseDate(value);
                effectiveDate = parseDate(effectiveDate);
                return (effectiveDate.diff(birthday, 'years') >= ageLimit);
            }
        } else return true;
    },
    validateDocument: ([type, value]) => {
        if (!value) return false;
        switch (type) {
            case ALL_DOCUMENT_TYPES.CERTIFICATE_OF_NATURALIZATION:
                return checkRegex(value, REGEX.CERTIFICATE_OF_NATURALIZATION);
            case ALL_DOCUMENT_TYPES.CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            case ALL_DOCUMENT_TYPES.DIVORCE_DECREE:
            case ALL_DOCUMENT_TYPES.NATIVE_AMERICAN_TRIBAL_DOCUMENT:
            case ALL_DOCUMENT_TYPES.VOTER_REGISTRATION_CARD:
            case ALL_DOCUMENT_TYPES.FOREIGN_PASSPORT:
                return checkRegex(value, REGEX.NO_SPACE_HYPHEN_AT_START);
            case ALL_DOCUMENT_TYPES.DRIVER_LICENSE:
                return checkRegex(value, REGEX.DRIVER_LICENSE);
            case ALL_DOCUMENT_TYPES.EMPLOYER_IDENTIFICATION_CARD:
                return checkRegex(value, REGEX.NO_SPACE_HYPHEN_AT_START);
            case ALL_DOCUMENT_TYPES.EMPLOYMENT_AUTHORIZATION_DOCUMENT: {
                if (value.search('-') !== -1) {
                    return checkRegex(value, REGEX.EMPLOYMENT_AUTHORIZATION_DOCUMENT_HYPHEN);
                }
                return checkRegex(value, REGEX.EMPLOYMENT_AUTHORIZATION_DOCUMENT_NO_HYPHEN);
            }
            case ALL_DOCUMENT_TYPES.DIPLOMA:
            case ALL_DOCUMENT_TYPES.IDENTIFICATION_CARD:
                return checkRegex(value, REGEX.NO_SPACE_HYPHEN_AT_START);
            case ALL_DOCUMENT_TYPES.MARRIAGE_CERTIFICATE:
                return checkRegex(value, REGEX.MARRIAGE_CERTIFICATE);
            case ALL_DOCUMENT_TYPES.MILITARY_DEPENDANT_ID_CARD:
            case ALL_DOCUMENT_TYPES.SSN:
                return (checkRegex(value, REGEX.SSN_HYPHEN) || checkRegex(value, REGEX.SSN_NO_HYPHEN));
            case ALL_DOCUMENT_TYPES.PERMANENT_RESIDENT_CARD:
                return checkRegex(value, REGEX.PERMANENT_RESIDENT_CARD);
            case ALL_DOCUMENT_TYPES.SCHOOL_ID_CARD:
            case ALL_DOCUMENT_TYPES.PROPERTY_DEED_OR_TITLE:
            case ALL_DOCUMENT_TYPES.MILITARY_CARD:
                return checkRegex(value, REGEX.NO_SPACE_HYPHEN_AT_START);
            case ALL_DOCUMENT_TYPES.US_COAST_GUARD_MARINER_CARD:
            case ALL_DOCUMENT_TYPES.PASSPORT:
                return checkRegex(value, REGEX.PASSPORT);
            case ALL_DOCUMENT_TYPES.BIRTH_RECORD:
                return checkRegex(value, REGEX.BIRTH_RECORD);
            default: return true;
        }
    },
    validateDateMDYFormat: ([value]) => checkRegex(value, /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/),

    dateNotGreaterThanCurrentDate: ([value, serverDate]) => {
         
        if (checkRegex(value, /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/)) {
            return getDateTimeInMillisecond(value) <= getDateTimeInMillisecond(serverDate);
        }
        return false;
    },
    digits: ([value]) => checkRegex(String(value), /^[0-9]*$/),

    digitsOrEmpty: ([value]) => checkRegex(value, /^[0-9]*$/, ['', null]),

    email: ([value]) => {
        return checkRegex(value, /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)$/);
    },
    nonMandatoryEmail: ([value]) => {
        if (value === '') return true;
        return checkRegex(value, /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(]?)$/);
    },
    exactLength: ([value, length]) => value && value.length === length,

    exactMatch: ([value, valuesToMatch]) => valuesToMatch.some(valueToMatch => valueToMatch.toLowerCase() === value.toLowerCase()),

    maxLength: ([value, length]) => (value === null || value === '') ? true : String(value).length <= length,


    minLength: ([value, length]) => (value === null || value === '') ? true : String(value).length >= length,

    multipleCounty: ([value, numberOfCounties]) => {
        if (numberOfCounties > 1) {
            return value !== '' && value !== null;
        }
        return true;
    },
    noLetters: ([value]) => checkRegex(value, /[a-zA-Z]/, [null], true),

    notEmpty: ([value]) => value !== '' && value !== null,

    notZeroAndNotEmpty: ([value]) => value !== 0 && value !== '' && value !== null,

    name: ([value]) => checkRegex(value, FIRST_NAME_REGEX),

    onlyLettersAndSplChars: ([value]) => checkRegex(value, /^[a-zA-Z~!#$^&*()\-:',. ]*$/),
    nonMandatoryOnlyLettersAndSplChars: ([value]) => {
        const spaceCount = (value.match(/ /g) || []).length;
        if (spaceCount <= 0) return true;
        return checkRegex(value, /^[A-Za-z0-9](?:[A-Za-z0-9_., -]*[A-Za-z0-9_.,-])?$/);
    },
    phoneNumber: ([value]) => {
        if (value === null || value === '') {
            return true;
        } else {
            const numbersQty = typeof value === 'string' && value.split('').filter(c => c.match(/^[0-9]*$/)).join('').length;
            return numbersQty === 10;
        }
    },
    ssn: ([value]) => {
        // format  the value if it contains '-'
        let formattedValue = value;
        if (value.search('-') !== -1) {
            formattedValue = value.replaceAll('-', '');
        }
        return checkRegex(formattedValue, /^([1-57-8][0-9]{2}|0([1-9][0-9]|[0-9][1-9])|6([0-57-9][0-9]|[0-9][0-57-9]))([1-9][0-9]|[0-9][1-9])([1-9]\d{3}|\d[1-9]\d{2}|\d{2}[1-9]\d|\d{3}[1-9])$/);
    },
    zipCode5Digits: ([value]) => checkRegex(value, /^\d{5}$/),
    nonMandatoryZipCode5Digits: ([value]) => {
        if (value === '') return true;
        return checkRegex(value, /^\d{5}?$/);
    }
};
